import { connect } from 'react-redux';
import mapDispatchToProps from './mapDispatchToProps';
import Component from './MemberModal';
import mapStateToProps from './mapStateToProps';

export default connect(mapStateToProps, mapDispatchToProps)(Component);
